export default "__VITE_ASSET__CvjNSu7e__"